const toTitleCase = (str: string) => {
  return (str || '')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const augmentEntityWithClientName = (entity: any, entityPrimaryKey: string, revert?: boolean) => ({
  ...entity,
  id: entity[entityPrimaryKey],
  CLIENT_DISPLAY_NAME: revert
    ? toTitleCase(entity?.CLIENT)
    : entity?.['CLIENT_DISPLAY_NAME'] || toTitleCase(entity?.CLIENT),
});
